export class ActiveSiteDays {
    siteId: number;
    day: number;

    constructor(siteId: number, day: number) {
      this.siteId = siteId;
      this.day = day;
    }
  }
